import React, { useState } from 'react';

import { Section, Row, Container, Column } from 'src/components-v2/Layout';
import { CmsSectionalHeader } from 'src/sections/Header';
import RichTextSwitch from 'src/containers/RichTextSwitch/RichTextSwitch';
import { imageCardTextNodes } from 'src/sections/Cards/CmsCardsSwitch/utils';

import TabbedNav from 'src/components-v3/TabbedNav/TabbedNav';

const TabbedCardsSection = ({ fields, sys }) => {
  const {
    backgroundColor,
    styles: stylesProp,
    header,
    imageCardTabs,
  } = fields || {};

  const [selectedIndex, setSelectedIndex] = useState(0);

  const currentTab = imageCardTabs?.[selectedIndex];
  const currentTabCards = currentTab?.fields?.cards;

  return (
    <Section
      sx={{ backgroundColor: backgroundColor || 'white', ...stylesProp }}
    >
      {header && (
        <CmsSectionalHeader sys={header?.sys} fields={header?.fields} />
      )}

      <TabbedNav
        tabs={imageCardTabs}
        selectedIndex={selectedIndex}
        onChange={setSelectedIndex}
      />

      <Container sx={{ maxWidth: '1448px', px: { xs: '24px', sm: '40px' } }}>
        <Row
          component='ul'
          sx={{
            flexWrap: { xs: 'wrap' },
            listStyle: 'none',
            '& img': {
              borderRadius: '1.6rem',
              mb: { xs: '2.4rem', sm: '1.6rem' },
            },
            '& h3, p': {
              mb: { xs: '0.8rem', sm: '1.6rem' },
            },
            '& p:nth-last-of-type(1):empty': {
              display: 'none',
            },
          }}
          rowSpacing={{ sm: 5, md: 10 }}
          columnSpacing={{ sm: 5, md: 10 }}
        >
          {currentTabCards?.map((card, index) => {
            if (!card) return null;
            return (
              <Column
                component='li'
                key={card?.sys?.id || index}
                xs={24}
                sm={12}
                sx={{ mb: { xs: '4rem', sm: 0 } }}
              >
                <RichTextSwitch
                  sys={card?.sys}
                  content={card?.fields?.body}
                  nodes={imageCardNodes}
                />
              </Column>
            );
          })}
        </Row>
      </Container>
    </Section>
  );
};

const imageCardNodes = {
  ...imageCardTextNodes,
  asset: {
    queryString: {
      xs: '?fm=webp&w=644&q=60',
      sm: '?fm=webp&w=1080&q=60',
      md: '?fm=webp&w=1080&q=60',
      lg: '?fm=webp&w=1080&q=60',
    },
    width: 644,
    height: 460,
  },
};

export default TabbedCardsSection;
